/**
 * English translations for Papelitos.
 */
export const en = {
  // --- Common ---
  teamA: 'Team A',
  teamB: 'Team B',
  back: '← Back',
  backToMenu: '← Back to Menu',
  continue: 'Continue',
  start: 'START',
  loading: 'Loading...',
  connecting: 'Connecting...',
  player: 'player',
  players: 'players',
  card: 'card',
  cards: 'cards',
  pts: 'pts',
  pt: 'pt',
  host: 'Host',
  you: 'you',
  round: 'Round',
  min: 'min',
  waiting: 'Waiting',

  // --- Main Menu ---
  appTitle: 'Pah-peh-lee-tohs',
  appSubtitle: 'The party card game',
  singleDevice: 'Single Device',
  hostMultiDevice: 'Host Multi-Device Game',
  joinGame: 'Join Game',
  rules: 'Rules',
  decksAvailable: '{0} decks available',
  cardsTotal: '{0} cards',

  // --- Rules ---
  rulesTitle: 'Rules',
  rulesSubtitle: 'How to play',
  round1Title: 'Round 1 — Describe It',
  round1Desc: 'Use any words to describe the card, but you CANNOT say any word in the title!',
  round2Title: 'Round 2 — One Word',
  round2Desc: 'Say exactly ONE word. No gestures!',
  round3Title: 'Round 3 — Act It Out',
  round3Desc: 'Physical acting only. No spoken words!',
  round4Title: 'Round 4 — Draw It',
  round4Desc: 'Draw on screen. No letters or numbers!',
  optional: 'Optional',

  // --- Round Rules (used in-game) ---
  roundName1: 'Describe It',
  roundName2: 'One Word',
  roundName3: 'Act It Out',
  roundName4: 'Draw It',
  roundDesc1: 'Use any words to describe the card — but you CANNOT say any word in the title!',
  roundDesc2: 'Say exactly ONE word to get your team to guess. No gestures!',
  roundDesc3: 'Use only physical acting. No spoken words allowed!',
  roundDesc4: 'Draw the card title on screen. No letters or numbers!',

  // --- Lobby ---
  gameLobby: 'Game Lobby',
  lobbySubtitle: 'Add players and assign teams',
  playerNamePlaceholder: 'Player name',
  add: 'Add',
  playersAdded: '{0} player{1} added',
  needAtLeast4: '(need at least 4)',
  unassignedDragHint: 'Unassigned — drag to a team',
  dropPlayersHere: 'Drop players here',
  startGame: 'Start Game',
  removePlayer: 'Remove player',
  nameTaken: 'Name already taken',
  nameTooLong: 'Name must be 1-20 characters',
  gameFull: 'Game is full (max 20 players)',

  // --- Setup ---
  gameSetup: 'Game Setup',
  setupSubtitle: 'Configure your game',
  chooseDeck: 'Choose a deck',
  customDeck: 'Custom Deck',
  customDeckDesc: 'Each player contributes their own cards',
  timerPerTurn: 'Timer per turn',
  cardsPerPlayer: 'Cards per player',
  totalDeck: 'Total deck: {0} players × {1} = {2} cards',
  playerOrder: 'Player order',
  shuffle: 'Shuffle',
  define: 'Define',
  enableRound4: 'Enable Round 4 (Drawing)',
  confirmAndPlay: 'Confirm & Play',
  backToLobby: '← Back to Lobby',
  pleaseSelectDeck: 'Please select a deck',

  // --- Round Interstitial ---
  roundN: 'ROUND {0}',
  letsGo: "Let's Go!",
  startingIn: 'Starting in {0}...',

  // --- Turn Waiting ---
  passPhoneTo: 'Pass the phone to',
  nextPlayer: 'Next Player',
  team: 'Team {0}',

  // --- Turn Active ---
  deckEmpty: 'Deck Empty!',
  deckEmptyDesc: 'All cards have been played this round.',
  cardsRemaining: '{0} card{1} remaining',
  skip: 'Skip',
  next: 'Next →',

  // --- Turn End ---
  timesUp: "Time's Up!",
  cardsCorrect: 'Cards correct',
  pointsEarned: 'Points earned',
  cardsSkipped: 'Cards skipped',
  pointsLost: 'Points lost',
  protestACard: 'Protest a Card',
  nextUp: 'Next up',
  waitingForHost: 'Waiting for host...',

  // --- Protest ---
  protest: 'Protest',
  protestSubtitle: 'Was the guess valid?',
  protestUpheld: 'Protest upheld — points removed',
  protestDismissed: 'Dismissed — points kept',
  teamsDisagreeHostDecides: 'Teams disagree — Host decides:',
  teamASays: 'Team A says:',
  teamBSays: 'Team B says:',
  valid: 'Valid ✓',
  invalid: 'Invalid ✗',
  skipAllContinue: 'Skip All & Continue',
  doneContinue: 'Done — Continue',
  protested: 'Protested',
  protestThisCard: 'Protest This Card',

  // --- Round Complete ---
  roundComplete: 'Round {0} Complete!',
  seeFinalResults: 'See Final Results',
  nextRound: 'Next Round →',
  totalA: 'Total A',
  totalB: 'Total B',

  // --- Game End ---
  gameOver: 'Game Over',
  teamAWins: 'Team A Wins!',
  teamBWins: 'Team B Wins!',
  itsATie: "It's a Tie!",
  playAgain: 'Play Again',
  mainMenu: 'Main Menu',

  // --- Custom Deck ---
  customDeckTitle: 'Custom Deck',
  cardsPerPlayerLabel: '{0} cards per player',
  passPhoneToPlayer: 'Pass the phone to:',
  imReady: "I'm Ready",
  progressLabel: 'Progress: {0}/{1} players done',
  playerCards: "{0}'s Cards",
  titleRequired: 'Title (required)',
  titlePlaceholder: 'What will people guess?',
  descriptionOptional: 'Description (optional)',
  descPlaceholder: 'A hint or clue',
  points: 'Points',
  addCard: 'Add Card ✓',
  cardsAdded: 'Cards added:',
  doneSubmitAll: 'Done — Submit All',
  cardsSaved: '✓ Cards Saved!',
  allPlayersSubmitted: 'All players have submitted their cards!',
  totalCardsReady: '{0} total cards ready',
  startPlaying: 'Start Playing!',
  passToNextPlayer: 'Pass phone to the next player',
  doNotScrollUp: 'Do NOT scroll up',
  titleRequiredError: 'Title is required',
  titleTooLong: 'Title must be 80 characters or less',
  cardAlreadyAdded: 'You already added this card',

  // --- Mid-Round Transition ---
  allCardsGuessed: 'All cards guessed!',
  continuesWith: '{0} continues with',
  remaining: 'remaining',

  // --- Multi Lobby ---
  newGame: 'New Game',
  enterNameToHost: 'Enter your name to host',
  yourNamePlaceholder: 'Your name',
  createGame: 'Create Game',
  shareThisCode: 'Share this code',
  playersConnected: '{0} player{1} connected',
  unassignedTapToAssign: 'Unassigned — tap to assign',
  addPlayerWithoutPhone: 'Add player without a phone',
  addPlayer: 'Add Player',
  leaveGame: 'Leave Game',
  joinGameTitle: 'Join Game',
  enterCodeSubtitle: 'Enter the 4-digit code',
  join: 'Join',
  joinAsReader: 'Join as Reader 📱',
  joinAsScoreboard: 'Join as Scoreboard 📊',
  enterValidCode: 'Enter a valid 4-digit code',
  cannotConnect: 'Cannot connect to server. Is backend running?',
  waitingForHostToStart: 'Waiting for host to start...',
  hostWillAssign: 'Host will assign you to a team',
  maxChars: 'Max 20 characters',
  connectedDevices: 'Connected Devices',
  yourRole: 'Your role',

  // --- Multi Gameplay ---
  hostIsChoosing: 'Host is choosing settings...',
  deck: 'Deck',
  timer: 'Timer',
  rounds: 'Rounds',
  order: 'Order',
  notSelected: 'Not selected',
  firstUp: 'First up:',
  yourTurn: 'Your Turn!',
  pressStartWhenReady: 'Press START when ready',
  nextUpColon: 'Next up:',
  waitingForThemToStart: 'Waiting for them to start...',
  startForThem: 'Start for them (Host)',
  isDescribing: '{0} is describing...',
  isReading: 'is reading',
  waitingForFirstCard: 'Waiting for first card...',
  lastCorrect: 'Last correct:',
  cardsProtested: '{0} card{1} protested this turn',
  loadingCard: 'Loading card...',
  allCardsSubmitted: 'All cards submitted! Starting game...',
  waitingForAllPlayers: 'Waiting for all players...',
  waitingForNextPlayer: 'Waiting for next player...',
  waitingForGameToStart: 'Waiting for game to start...',
  currentlyEntering: '{0} is entering cards...',
  entering: 'entering...',
  lendPhoneTo: 'Lend your phone to:',
  lendTo: 'Lend to {0}',
  handPhoneTo: 'Hand this phone to',
  theyWillEnterCards: 'They will enter their cards privately.',
  yourCardsAreSafe: 'Your cards are safe and hidden.',
  imPlayerStart: "I'm {0} — Start",
  handPhoneBackTo: 'Hand phone back to {0}',
  done: 'Done',
  pending: 'pending',
  customDeckProgress: 'Custom Deck Progress',
  playersSubmitted: '{0}/{1} players submitted',
  selectPlayerToEnter: 'Select a player to enter their cards:',
  progress: 'Progress',

  // --- Validation ---
  needPlayers: 'Need at least {0} players (have {1})',
  playersUnassigned: '{0} player(s) not assigned to a team',
  teamNeedsPlayers: 'Team {0} needs at least {1} players',

  // --- Rejoin & QR ---
  rejoinGame: 'Rejoin Game',
  scanToJoin: 'Scan to join',

  // --- Reader Disconnect ---
  readerDisconnected: 'Reader Disconnected',
  readerDisconnectedDesc: 'The Reader device lost connection. Timer is paused.',
  waitingForReaderReconnect: 'Waiting for Reader to reconnect...',
  assignNewReader: 'Assign New Reader',
  readerTimeout: 'Reader has not reconnected. You can assign a new Reader device.',
} as const;

export type TranslationKey = keyof typeof en;
